import React from 'react';
import styled from 'styled-components';
import { useFlexibleTranslation } from '../contexts/LanguageContext';
import { phErrorCaught } from '../utils/posthogEvents';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 20px;
  text-align: center;
  background-color: #f8f9fa;
`;

const ErrorMessage = styled.div`
  margin: 20px;
  padding: 20px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  max-width: 600px;
`;

const RetryButton = styled.button`
  padding: 10px 20px;
  margin-top: 20px;
  background-color: #ff6b35;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #e65a2a;
  }
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    phErrorCaught(error, { source: 'react_error_boundary' });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <ErrorMessage>
            <h2>{this.props.t ? this.props.t('errorBoundary.somethingWentWrong', 'Something went wrong') : 'Something went wrong'}</h2>
            <p>{this.props.t ? this.props.t('errorBoundary.apologizeInconvenience', 'We apologize for the inconvenience. Please try again.') : 'We apologize for the inconvenience. Please try again.'}</p>
            {process.env.NODE_ENV === 'development' && (
              <pre style={{ textAlign: 'left', marginTop: '20px' }}>
                {this.state.error?.toString()}
              </pre>
            )}
            <RetryButton onClick={this.handleRetry}>
              {this.props.t ? this.props.t('errorBoundary.retry', 'Retry') : 'Retry'}
            </RetryButton>
          </ErrorMessage>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

// Wrapper component to provide translation context
const ErrorBoundaryWithTranslation = (props) => {
  const { t } = useFlexibleTranslation();
  return <ErrorBoundary {...props} t={t} />;
};

export default ErrorBoundaryWithTranslation; 